import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Clinic } from '@models/clinic';
import { Patient } from '@models/patient';
import { Prescription } from '@models/prescriptions/prescription';
import { User } from '@models/user';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { exportPDF } from '@progress/kendo-drawing';
import { BlobService } from '@services/blob.service';
import { UsersService } from '@services/users.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-prescription-details',
  templateUrl: './prescription-details.component.html',
  styleUrls: ['./prescription-details.component.less'],
})
export class PrescriptionDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('pdf', { static: true }) prescriptionDetails: PDFExportComponent;
  @Input() clinic: Clinic;
  @Input() patient: Patient;
  @Input() prescription: Prescription[];
  @Input() signatureUrl: string;
  currentUser: User;
  unsub: Subject<void> = new Subject<void>();

  constructor(private blobService: BlobService, private usersService: UsersService) {}

  ngOnInit() {
    this.currentUser = this.usersService.loggedInUser;
  }

  public getPrescriptionDateStr(date: Date) {
    return moment(date).local().format('MMMM D, YYYY');
  }

  public getCurrentDayStr() {
    return moment(new Date()).format('MMMM D, YYYY');
  }

  public async exportToPDF(): Promise<{ blob: Blob; base64: string; url: string }> {
    const group = await this.prescriptionDetails.export();
    const dataUri = await exportPDF(group /*, { title: this.getFileName() }*/);
    const base64 = dataUri.replace('data:application/pdf;base64,', '');
    const blob = await this.blobService.convertBase64toBlob(base64, 'application/pdf');
    const printable = URL.createObjectURL(blob);
    return { blob, base64, url: printable };
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
